/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AuditFilterActorOption } from './auditFilterActorOption';

export interface AuditFilterOptionsResponse {
  actions: string[];
  severities: string[];
  actors: AuditFilterActorOption[];
  truncated?: boolean;
}
